import type { MessageKey } from "./en";
import { APP_NAME } from "../config/brand";

/** German UI copy — must cover every key in en.ts (pinned by a test). */
export const de: Record<MessageKey, string> = {
  "app.name": APP_NAME,
  "landing.login": "Anmelden",
  "landing.getStarted": "Loslegen",
  "landing.eyebrow": "telc- & Goethe-Prüfungsvorbereitung",
  "landing.h1": "Bestehen Sie Ihre Deutschprüfung mit Sicherheit.",
  "landing.sub": "Vollständige Prüfungsübungen, ein strukturierter Kurs und KI-Feedback für jedes Niveau von A1 bis C1 — telc und Goethe, alles an einem Ort.",
  "landing.ctaPrimary": "Jetzt lernen",
  "landing.ctaSecondary": "Was drin ist",
  "landing.boards": "Übungsmaterial nach dem Format der telc- und Goethe-Prüfungen.",
  "landing.statItems": "Prüfungsaufgaben",
  "landing.statLessons": "geführte Lektionen",
  "landing.statWords": "Wörter Wortschatz",
  "landing.statLevels": "jedes Niveau",
  "landing.featuresTitle": "Alles, was Sie bis zur Prüfung brauchen.",
  "landing.featuresSub": "Kein Videokurs und keine Karteikarten-App — der ganze Weg vom ersten Wort bis zum Prüfungstag.",
  "landing.f1t": "Prüfungsübungen",
  "landing.f1b": "2.736 Aufgaben zu Lesen, Hören, Schreiben und Sprechen — genau im telc- und Goethe-Format, mit sofortiger Bewertung.",
  "landing.f2t": "Geführter Kurs",
  "landing.f2b": "240 Lektionen auf einem klaren Weg — Wortschatz, eine Grammatikregel, eine Tabelle, ein Dialog, Übungen und je eine kurze Schreib- und Sprechaufgabe.",
  "landing.f3t": "Nachschlagen & Wiederholen",
  "landing.f3b": "50 Grammatiktabellen und 7.200 Wörter, jederzeit griffbereit — mit verteilter Wiederholung, damit die Wörter sitzen.",
  "landing.f4t": "KI-Schreib- & Sprechcoach",
  "landing.f4b": "Schreiben oder sprechen Sie und erhalten Sie in Sekunden Feedback — bewertet nach den echten Prüfungskriterien, mit Korrekturen.",
  "landing.f5t": "Modellprüfungen",
  "landing.f5b": "Vollständige Prüfungssimulationen, die jeden Teil an der 60%-Grenze bewerten — so wissen Sie vor dem Ernstfall, wo Sie stehen.",
  "landing.f6t": "Ihr Können-Check",
  "landing.f6b": "Sechs Fertigkeitswerte aus allem, was Sie tun, plus die eine nächste Aufgabe — kein Rätselraten mehr, was zu üben ist.",
  "landing.pricingTitle": "Kaufen Sie genau das, was Sie brauchen.",
  "landing.pricingSub": "Ein einzelnes Niveau, ein komplettes Niveau oder ein Paket für eine ganze Schule. Zahlen Sie für eine Fertigkeit oder den ganzen Weg.",
  "landing.popular": "Am beliebtesten",
  "landing.planLearnerT": "Ein Lernender, ein Niveau",
  "landing.planLearnerB": "Kaufen Sie nur den Kurs oder nur die Prüfungsübungen für Ihr Niveau. Sie sind Konto und Lernender zugleich.",
  "landing.planCompleteT": "Komplettes Niveau",
  "landing.planCompleteB": "Kurs und Prüfungsübungen für ein Niveau zusammen — günstiger als beide Hälften einzeln, inklusive KI-Feedback.",
  "landing.planSchoolT": "Für Schulen",
  "landing.planSchoolB": "Mehrplatz-Pakete mit allen Niveaus. Legen Sie Konten für Ihre Lernenden an und verwalten Sie alles zentral.",
  "landing.finalTitle": "Bereit anzufangen?",
  "landing.finalSub": "Erstellen Sie ein Konto und beginnen Sie auf Ihrem Niveau. Ihre Schule oder unser Team schaltet den Rest frei.",
  "landing.footer": "Deutsch-Prüfungsvorbereitung für telc und Goethe.",
  "landing.howTitle": "Vom ersten Wort bis zum Prüfungstag.",
  "landing.step1t": "Niveau bestimmen",
  "landing.step1b": "Ein kurzer Einstufungstest verortet Sie auf der GER-Skala und zeigt Ihre sechs Fertigkeitswerte — kein Rätselraten, wo Sie anfangen.",
  "landing.step2t": "Lernen und üben",
  "landing.step2b": "Arbeiten Sie den geführten Kurs und echte Prüfungsaufgaben Seite an Seite durch — mit verteilter Wiederholung, damit jedes Wort sitzt.",
  "landing.step3t": "Modellprüfung ablegen",
  "landing.step3b": "Eine vollständige Prüfung unter Zeit bewertet jeden Teil an der 60%-Grenze — so hält der Prüfungstag keine Überraschungen bereit.",
  "landing.ladderNote": "jedes Niveau abgedeckt",
  "nav.dashboard": "Übersicht",
  "nav.store": "Shop",
  "store.title": "Shop",
  "store.subtitle": "Fügen Sie Niveaus und KI-Guthaben zu Ihrem Konto hinzu.",
  "store.levels": "Niveaus",
  "store.owned": "Im Besitz",
  "store.credits": "{count} Credits",
  "store.creditMonthly": "{credits} pro Monat inklusive",
  "credits.low": "Ihre Schule hat {percent}% des KI-Guthabens dieses Monats verbraucht.",
  "credits.outAdmin": "Das KI-Guthaben Ihrer Schule ist fuer diesen Monat aufgebraucht. Schreib-Feedback, Sprechpartner und Antworterklaerungen pausieren, bis Sie aufladen.",
  "credits.outLearner": "Das KI-Guthaben Ihrer Schule ist fuer diesen Monat aufgebraucht, deshalb pausiert das KI-Feedback. Bitten Sie Ihre Lehrkraft aufzuladen.",
  "credits.topUp": "Aufladen",
  "store.creditBalance": "KI-Guthaben",
  "store.creditsTitle": "KI-Guthaben",
  "store.creditsBody": "Credits treiben KI-Schreibfeedback, den Sprechpartner und Antwort-Erklärungen an. Ihr Paket enthält ein monatliches Guthaben; hier kaufen Sie bei Bedarf mehr.",
  "store.kind.learn": "Kurs",
  "store.kind.practice": "Übungen",
  "store.kind.complete": "Komplett",
  "store.total": "Gesamt",
  "store.itemCount": "{count} im Warenkorb",
  "store.placeOrder": "Bestellung aufgeben",
  "store.orderPlaced": "Bestellung aufgegeben — per Überweisung bezahlen",
  "store.amountToPay": "Zu zahlender Betrag",
  "store.reference": "Verwendungszweck",
  "store.quoteReference": "Geben Sie diesen Verwendungszweck bei der Überweisung an, damit wir Ihre Zahlung zuordnen können.",
  "store.transferTo": "Überweisen an",
  "store.accountName": "Kontoinhaber",
  "store.accountNumber": "Kontonummer",
  "store.bankName": "Bank",
  "store.ifsc": "IFSC",
  "store.orderItems": "Ihre Bestellung",
  "store.contact": "Fragen? Kontakt",
  "nav.orders": "Bestellungen",
  "nav.classes": "Klassen",
  "tour.body.classes": "Legen Sie fest, wer was lernt. Weisen Sie einer Klasse Niveaus zu — alle Mitglieder erhalten sie — oder geben Sie einzelnen Lernenden etwas zusätzlich.",
  "classes.title": "Klassen",
  "classes.subtitle": "Ihre Schule kauft ein Niveau einmal; hier wählen Sie, welche Lernenden es bekommen. Weisen Sie es einer Klasse zu, dann erhält es jedes Mitglied — Einzelne können Zusätzliches bekommen.",
  "classes.newClass": "Neue Klasse",
  "classes.name": "Klassenname",
  "classes.namePlaceholder": "z. B. Klasse 1, Abendkurs B1",
  "classes.create": "Klasse anlegen",
  "classes.empty": "Noch keine Klassen. Legen Sie eine an, um Niveaus zuzuweisen.",
  "classes.delete": "Löschen",
  "classes.modules": "Niveaus für diese Klasse",
  "classes.members": "Lernende in dieser Klasse ({count})",
  "classes.noPupils": "Noch keine Lernenden — legen Sie sie zuerst unter Team an.",
  "classes.noModules": "Ihre Schule hat noch keine Niveaus. Kaufen Sie zuerst eines im Shop.",
  "classes.saved": "Gespeichert.",
  "classes.individual": "Einzelne Lernende",
  "classes.individualBody": "Für Ausnahmen — wenn jemand etwas braucht, das seine Klasse nicht hat. Dies kommt zu den Klassen-Zuweisungen hinzu.",
  "classes.pupil": "Lernende/r",
  "classes.choosePupil": "Lernende/n wählen…",
  "classes.extraModules": "Zusätzliche Niveaus für diese Person",
  "classes.effective": "Aktuell zugänglich",
  "classes.nothingYet": "noch nichts",
  "classes.grantAll": "Alles zuweisen, was die Schule besitzt",
  "classes.autoGrant": "Neue Lernende",
  "classes.autoGrantBody": "Neue Lernende erhalten beim Annehmen der Einladung automatisch alle Niveaus, die die Schule besitzt. Schalten Sie dies aus, wenn Sie jede Person einzeln zuweisen möchten.",
  "admin.orders.heading": "Überweisungsbestellungen",
  "admin.orders.headingSub": "Zahlungen abgleichen und die Bankdaten verwalten, an die Lernende überweisen.",
  "admin.orders.title": "Offene Bestellungen",
  "admin.orders.subtitle": "Markieren Sie eine Bestellung als bezahlt, sobald die Überweisung eingeht — das schaltet die Pakete frei.",
  "admin.orders.none": "Keine offenen Bestellungen.",
  "admin.orders.ref": "Verwendungszweck",
  "admin.orders.tenant": "Konto",
  "admin.orders.items": "Artikel",
  "admin.orders.amount": "Betrag",
  "admin.orders.markPaid": "Als bezahlt markieren",
  "admin.orders.cancel": "Stornieren",
  "admin.orders.paidDone": "Bestellung freigeschaltet.",
  "admin.orders.cancelled": "Bestellung storniert.",
  "admin.pay.title": "Zahlungsdaten",
  "admin.pay.subtitle": "Das Bankkonto und der Kontakt, die Lernenden in der Überweisungsanleitung angezeigt werden.",
  "admin.pay.contactEmail": "Kontakt-E-Mail",
  "admin.pay.note": "Hinweis für Käufer",
  "admin.pay.save": "Speichern",
  "admin.pay.saved": "Zahlungsdaten gespeichert.",
  "tour.help": "Kurze Einführung",
  "locked.title": "{level} {kind} gehört noch nicht zu Ihrem Paket",
  "locked.body": "Es ist nichts schiefgegangen — dieses Niveau ist für Ihr Konto einfach noch nicht freigeschaltet. Fügen Sie {level} {kind} im Shop hinzu, dann steht es sofort bereit.",
  "locked.cta": "Im Shop freischalten",
  "learn.objectives": "Am Ende dieser Lektion können Sie",
  "learn.lineGloss": "Satz für Satz",
  "learn.wordBank": "Wortschatz",
  "learn.pronunciation": "Aussprache",
  "learn.minimalPairs": "Hören Sie den Unterschied",
  "learn.culture": "Landeskunde",
  "learn.translation": "Ins Deutsche übersetzen",
  "learn.translationHint": "Schreiben Sie jeden Satz auf Deutsch und zeigen Sie dann die Musterlösung.",
  "learn.showAnswers": "Lösungen zeigen",
  "learn.lessonTest": "Lernkontrolle",
  "learn.points": "Punkte",
  "learn.submitTest": "Abgeben",
  "learn.yourScore": "Ihr Ergebnis",
  "learn.recall": "Können Sie sich erinnern?",
  "learn.reveal": "Antwort zeigen",
  "learn.lockedBuy": "Noch nicht in Ihrem Paket — dieses Niveau im Shop freischalten",
  "learn.lockedAsk": "Noch nicht in Ihrem Paket — bitten Sie Ihre Schulverwaltung, dieses Niveau freizuschalten.",
  "locked.askAdmin": "Bitten Sie Ihre Schulverwaltung, {level} {kind} für Ihr Konto freizuschalten.",
  "locked.askAdminGeneric": "Bitten Sie Ihre Schulverwaltung, das für Sie freizuschalten.",
  "store.adminOnly": "Ihre Schulverwaltung bestellt die Niveaus für Ihr Konto. Bitten Sie sie um das, was Sie brauchen.",
  "locked.genericTitle": "Für Ihr Konto nicht freigeschaltet",
  "locked.genericBody": "Ihr Paket enthält das noch nicht. Im Shop können Sie es hinzufügen.",
  "tour.step": "{n} von {total}",
  "tour.next": "Weiter",
  "tour.back": "Zurück",
  "tour.skip": "Überspringen",
  "tour.done": "Alles klar",
  "tour.welcome.title": "Willkommen — so funktioniert es",
  "tour.welcome.body": "Eine kurze Tour: wo alles ist und was Sie zuerst tun. Dauert etwa 30 Sekunden — mit dem ?-Knopf können Sie sie jederzeit wiederholen.",
  "tour.askDoubt.title": "In Ihrer eigenen Sprache fragen",
  "tour.askDoubt.body": "Sie ueben auf Deutsch, muessen aber nie darin feststecken. Stellen Sie Ihre Frage bei jeder Lektion oder Uebung auf Hindi, Punjabi oder Englisch - die Antwort kommt in derselben Sprache zurueck.",
  "tour.final.title": "Womit Sie anfangen",
  "tour.final.body": "Starten Sie auf Ihrer Übersicht — dort sehen Sie unsere Empfehlung und Ihren Können-Check. Holen Sie sich ein Niveau im Shop und beginnen Sie dann unter Lernen mit Lektion 1.",
  "tour.body.dashboard": "Ihre Startseite. Hier sehen Sie unsere Empfehlung, Ihre sechs Fertigkeitswerte und die nächste sinnvolle Aufgabe.",
  "tour.body.learn": "Ihr Kurs, Lektion für Lektion der Reihe nach. Jede Lektion hat Wortschatz, eine Grammatikregel, einen Dialog, Übungen sowie eine kurze Schreib- und Sprechaufgabe.",
  "tour.body.reference": "Schlagen Sie jederzeit alles nach — Grammatiktabellen und Wortlisten für jedes Niveau, dazu Wiederholung, bis die Wörter sitzen.",
  "tour.body.notebook": "Ihr privater Notizblock. Halten Sie beim Lernen eine Regel, ein Wort oder eine Frage fest — es bleibt bei Ihrem Konto und nur Sie sehen es.",
  "tour.body.store": "Hier holen Sie sich ein Niveau. Wählen Sie den Kurs, die Prüfungsübungen oder beides und geben Sie Ihre Bestellung auf. Bis dahin bleiben Lektionen und Übungen gesperrt.",
  "tour.body.practice": "Echte Prüfungsaufgaben im telc- und Goethe-Format — Lesen, Hören, Schreiben und Sprechen, sofort bewertet. Auch vollständige Modellprüfungen finden Sie hier.",
  "tour.body.speak": "Sprechen Sie mit dem KI-Partner und erhalten Sie Feedback zu Ihrem Sprechen — bewertet wie in der Prüfung.",
  "tour.body.team": "Fügen Sie Lehrkräfte und Lernende zu Ihrer Schule hinzu und verwalten Sie deren Konten.",
  "tour.body.access": "Legen Sie fest, wer was sehen und tun darf — Rechte pro Person vergeben oder entziehen.",
  "tour.body.billing": "Ihr Tarif, Rechnungen und Zahlungen.",
  "tour.body.tenants": "Alle Schulen auf der Plattform — anlegen, ansehen und Module verwalten.",
  "tour.body.orders": "Überweisungsbestellungen, die noch abzugleichen sind. Als bezahlt markieren schaltet die Pakete frei.",
  "tour.body.revenue": "Was die Plattform über alle Schulen hinweg einnimmt.",
  "tour.body.ai": "Wählen Sie, welcher KI-Anbieter die Anfragen der Plattform beantwortet.",
  "tour.body.aiUsage": "Sehen Sie, wie viele KI-Tokens Ihre Lernenden pro Monat verbrauchen.",
  "usage.name": "Name",
  "store.error": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "store.recommended": "Empfohlen",
  "admin.credits.title": "KI-Guthaben",
  "admin.credits.thisMonth": "{granted} gewährt, {spent} verbraucht diesen Monat",
  "admin.credits.amount": "Betrag",
  "admin.credits.reason": "Grund",
  "admin.credits.reasonHint": "z. B. Kulanz, Erstattung, Korrektur",
  "admin.credits.apply": "Anpassung anwenden",
  "admin.credits.done": "Guthaben aktualisiert.",
  "admin.credits.asTokens": "= {tokens} Tokens",
  "admin.credits.monthlyAsTokens": "Das sind {tokens} Tokens pro Monat. Credits, nicht Tokens - 1 Credit = 100 Tokens.",
  "admin.credits.monthly": "Monatliches Guthaben",
  "admin.credits.monthlyHint": "Credits, die zu Monatsbeginn automatisch gutgeschrieben werden. 0 nutzt das Guthaben des Tarifs. Änderungen gelten ab der nächsten Gutschrift.",
  "admin.credits.monthlySave": "Guthaben speichern",
  "admin.credits.monthlySaved": "Monatliches Guthaben gespeichert.",
  "admin.credits.failed": "Guthaben konnte nicht angepasst werden.",
  "nav.reference": "Nachschlagen",
  "nav.notebook": "Notizbuch",
  "notebook.tabNotes": "Notizen",
  "notebook.tabWriting": "Schreibuebung",
  "writing.intro": "Schreiben Sie etwas auf Deutsch, und der Coach korrigiert es - mit Punktzahl, den wichtigsten Korrekturen und dem naechsten Uebungsschritt. Was Sie moechten: Tagebuch, E-Mail, Meinung.",
  "writing.level": "Niveau",
  "writing.levelHint": "Woran gemessen wird.",
  "writing.topic": "Thema",
  "writing.topicHint": "optional",
  "writing.topicPlaceholder": "z. B. mein Wochenende, mein Beruf",
  "writing.yourText": "Ihr Text",
  "writing.placeholder": "Schreiben Sie hier auf Deutsch...",
  "writing.words": "Wörter",
  "writing.submit": "Feedback erhalten",
  "writing.past": "Fruehere Texte",
  "writing.corrections": "Korrekturen",
  "writing.improvements": "Verbesserungspotenzial",
  "writing.whatYouWrote": "Ihr Text",
  "writing.again": "Neuen Text schreiben",
  "writing.noFeedback": "Fuer diesen Text wurde kein Feedback gespeichert.",
  "writing.notConfigured": "Der KI-Schreibcoach ist auf diesem Server noch nicht aktiviert — bitte wenden Sie sich an Ihre Administration.",
  "notebook.moveTo": "In Tab verschieben",
  "notebook.bold": "Fett",
  "notebook.highlight": "Markieren",
  "notebook.formatHint": "Text markieren, dann B oder H",
  "notebook.allNotes": "Allgemein",
  "notebook.newSection": "+ neuer Tab",
  "notebook.source": "Aus einer Lektion gespeichert",
  "placement.title": "Wo sollten Sie anfangen?",
  "placement.subtitle": "Ein paar Fragen, die leichteste zuerst. Antworten Sie, was Sie koennen, und lassen Sie den Rest aus - genau darum geht es.",
  "placement.progress": "Frage {current} von {total}",
  "placement.next": "Weiter",
  "placement.back": "Zurueck",
  "placement.finish": "Mein Niveau anzeigen",
  "placement.dontKnowHint": "Unsicher? Lassen Sie die Frage aus - Raten hilft bei der Einstufung nicht.",
  "placement.noQuestions": "Es sind noch keine Einstufungsfragen verfuegbar.",
  "placement.skipQuestion": "Diese Frage kann nicht angezeigt werden - bitte weiter.",
  "placement.startHere": "Hier anfangen",
  "placement.reasonNext": "Die Niveaus darunter haben Sie sicher gemeistert - hier sollte Ihr Kurs beginnen.",
  "placement.reasonBeginner": "Wir beginnen ganz vorne. Das ist fuer die meisten richtig - die ersten Lektionen gehen schnell, wenn Sie schon etwas Deutsch koennen.",
  "placement.reasonTop": "Sie haben alles beantwortet. Das ist das hoechste Niveau, das wir derzeit unterrichten.",
  "placement.startLearning": "Kurs starten",
  "placement.goPractice": "Uebungsaufgaben ausprobieren",
  "notebook.saveHere": "In mein Notizbuch",
  "notebook.saveTitle": "Im Notizbuch behalten",
  "notebook.saveFrom": "Aus {lesson} - Ihre Notiz verlinkt hierher zurueck.",
  "notebook.savePlaceholder": "Markieren Sie zuerst Text auf der Seite, oder tippen Sie ihn hier",
  "notebook.saved": "Im Notizbuch gespeichert.",
  "levels.title": "Ihre Niveaus",
  "levels.lessons": "{done}/{total} Lektionen",
  "levels.practice": "{done}/{total} Uebungsteile",
  "levels.markComplete": "Als abgeschlossen markieren",
  "levels.done": "Abgeschlossen",
  "levels.undo": "Rueckgaengig",
  "levels.keepGoing": "Weiter so",
  "levels.wellDone": "{level} abgeschlossen - gut gemacht.",
  "notebook.title": "Mein Notizbuch",
  "notebook.subtitle": "Ein privater Notizblock für Regeln, Wörter und Fragen — nur Sie sehen ihn.",
  "notebook.placeholder": "Notiz schreiben…",
  "notebook.add": "Notiz hinzufügen",
  "notebook.edit": "Bearbeiten",
  "notebook.delete": "Löschen",
  "notebook.empty": "Noch keine Notizen. Schreiben Sie oben Ihre erste.",
  "reference.title": "Nachschlagewerk",
  "reference.subtitle": "Grammatikregeln, Tabellen und Wortschatz für jedes Niveau — jederzeit zum Nachschlagen.",
  "reference.grammar": "Grammatik",
  "reference.vocab": "Wortschatz",
  "reference.tables": "Tabellen",
  "reference.rules": "Regeln",
  "reference.search": "Suchen…",
  "reference.noResults": "Keine Treffer für Ihre Suche.",
  "reference.wordCount": "{count} Wörter auf diesem Niveau",
  "review.tab": "Wiederholen",
  "review.due": "{count} heute fällig",
  "review.learned": "{count} von {total} gelernt",
  "review.sessionDone": "Runde geschafft",
  "review.reviewed": "Sie haben {count} Wörter wiederholt.",
  "review.again": "Weiter wiederholen",
  "review.position": "{n} von {total}",
  "review.newWord": "Neues Wort",
  "review.box": "Fach {box}",
  "review.reveal": "Bedeutung zeigen",
  "review.plural": "Plural",
  "review.forgot": "Nicht gewusst",
  "review.knew": "Gewusst",
  "review.empty": "Im Moment gibt es nichts zu wiederholen.",
  "kc.title": "Ihr Können-Check",
  "kc.doNext": "Das kommt als Nächstes",
  "kc.notStarted": "noch nicht begonnen",
  "kc.needMore": "noch {count} bis zur Auswertung",
  "kc.overallLocked": "noch {count} Fertigkeiten bis zur Gesamtnote",
  "kc.action.review_vocab": "{count} fällige Wörter wiederholen",
  "kc.action.start_skill": "{skill} beginnen — {count} Aufgaben schalten Ihre Bewertung frei",
  "kc.action.finish_evidence": "Noch {count} in {skill} bis zur Bewertung",
  "kc.action.improve_skill": "{skill} verbessern — zurzeit {count}%",
  "skill.wortschatz": "Wortschatz",
  "skill.grammatik": "Grammatik",
  "skill.lesen": "Lesen",
  "skill.hoeren": "Hören",
  "skill.schreiben": "Schreiben",
  "skill.sprechen": "Sprechen",
  "nav.team": "Team",
  "nav.access": "Zugriff",
  "nav.tenants": "Mandanten",
  "nav.billing": "Abrechnung",
  "nav.revenue": "Umsatz",
  "nav.profile": "Mein Konto",

  "profile.title": "Mein Konto",
  "profile.subtitle": "Aktualisieren Sie Ihre Daten und Ihr Passwort.",
  "profile.details": "Profildaten",
  "profile.fullName": "Vollständiger Name",
  "profile.phone": "Telefon",
  "profile.voice": "Stimme",
  "profile.voiceHint": "Die Stimme fuer den Sprechpartner und die Hoeruebungen.",
  "profile.language": "Sprache",
  "profile.emailLocked": "Wenden Sie sich an den Support, um Ihre E-Mail-Adresse zu ändern.",
  "profile.saved": "Profil aktualisiert.",
  "profile.password.title": "Passwort",
  "profile.password.current": "Aktuelles Passwort",
  "profile.password.new": "Neues Passwort",
  "profile.password.confirm": "Neues Passwort bestätigen",
  "profile.password.submit": "Passwort ändern",
  "profile.password.mismatch": "Die neuen Passwörter stimmen nicht überein.",
  "profile.password.changed": "Passwort geändert.",
  "profile.aiUsage": "KI-Nutzung",
  "twofa.title": "Zwei-Faktor-Authentifizierung",
  "twofa.on": "Zwei-Faktor-Authentifizierung ist aktiv",
  "twofa.off": "Fügen Sie beim Login einen zweiten Schritt für mehr Sicherheit hinzu.",
  "twofa.enable": "Aktivieren",
  "twofa.disable": "Deaktivieren",
  "twofa.disabled": "Zwei-Faktor-Authentifizierung deaktiviert.",
  "twofa.code": "Code aus Ihrer App",
  "twofa.scanIntro": "Scannen Sie dies mit Ihrer Authenticator-App und geben Sie zur Bestätigung den 6-stelligen Code ein.",
  "twofa.manualKey": "Können Sie nicht scannen? Geben Sie diesen Schlüssel manuell ein:",
  "twofa.recoveryIntro": "Bewahren Sie diese Wiederherstellungscodes sicher auf — jeder funktioniert einmal, falls Sie Ihr Gerät verlieren. Sie werden nicht erneut angezeigt.",
  "twofa.done": "Fertig",
  "twofa.disableIntro": "Geben Sie einen aktuellen Code (oder einen Wiederherstellungscode) ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.",
  "usage.today": "Heute",
  "usage.thisWeek": "Diese Woche",
  "usage.thisMonth": "Diesen Monat",
  "usage.left": "{pct}% übrig",
  "usage.used": "{used} von {limit} Tokens verbraucht",
  "usage.learners": "KI-Nutzung nach Lernenden",
  "usage.tenants": "KI-Nutzung nach Mandant",
  "usage.tokensThisMonth": "Tokens diesen Monat",
  "usage.none": "Noch keine KI-Nutzung.",
  "nav.aiUsage": "KI-Nutzung",
  "nav.group.learn": "Lernen",
  "nav.group.practice": "Ueben",
  "nav.group.school": "Schule",
  "nav.group.account": "Konto",
  "nav.group.revenue": "Umsatz",
  "nav.group.platform": "Mandanten",
  "nav.group.ai": "KI",
  "nav.menu": "Menü",
  "nav.closeMenu": "Menü schließen",
  "nav.switchLanguage": "Sprache wechseln",
  "nav.notifications": "Benachrichtigungen",
  "nav.logout": "Abmelden",

  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.login": "Anmelden",
  "auth.login.title": "Willkommen zurück",
  "auth.2fa.title": "Zwei-Faktor-Authentifizierung",
  "auth.2fa.subtitle": "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein (oder einen Wiederherstellungscode).",
  "auth.2fa.code": "Authentifizierungscode",
  "auth.2fa.verify": "Bestätigen",
  "auth.login.subtitle": "Melden Sie sich in Ihrem Arbeitsbereich an",
  "auth.forgot": "Passwort vergessen?",
  "auth.forgot.title": "Passwort zurücksetzen",
  "auth.forgot.subtitle": "Wir senden Ihnen einen Link per E-Mail.",
  "auth.forgot.submit": "Link senden",
  "auth.reset.title": "Neues Passwort wählen",
  "auth.reset.password": "Neues Passwort",
  "auth.reset.submit": "Passwort speichern",
  "auth.reset.done": "Passwort gespeichert. Sie können sich jetzt anmelden.",
  "auth.invite.title": "Konto einrichten",
  "auth.invite.for": "Sie richten das Konto ein für",
  "auth.invite.submit": "Konto aktivieren",
  "auth.backToLogin": "Zurück zur Anmeldung",
  "auth.name": "Ihr Name",
  "auth.signup.title": "Konto erstellen",
  "auth.signup.subtitle": "Fangen Sie an, Deutsch zu lernen — den Tarif wählen Sie später, nicht jetzt.",
  "auth.createAccount": "Konto erstellen",
  "auth.passwordHint": "Mindestens 8 Zeichen.",
  "auth.haveAccount": "Sie haben schon ein Konto?",
  "auth.newHere": "Neu hier?",
  "onboarding.title": "Lassen Sie uns starten",
  "onboarding.subtitle": "Fünf kurze Fragen, damit wir Ihnen das richtige Niveau und den passenden Plan zeigen können. Was Sie kaufen, entscheiden Sie später.",
  "onboarding.stepOf": "Schritt {n} von {total}",
  "onboarding.back": "Zurück",
  "onboarding.next": "Weiter",
  "onboarding.finish": "Meine Empfehlung ansehen",
  "onboarding.q.goal": "Warum lernen Sie Deutsch?",
  "onboarding.q.board": "Welche Prüfung haben Sie im Blick?",
  "onboarding.q.level": "Wie viel Deutsch können Sie schon?",
  "onboarding.q.focus": "Auf welches Niveau möchten Sie sich jetzt konzentrieren?",
  "onboarding.q.timeline": "Wie viel Zeit können Sie investieren?",
  "onboarding.goal.exam": "Eine Prüfung bestehen",
  "onboarding.goal.work": "Beruf & Karriere",
  "onboarding.goal.study": "Studium",
  "onboarding.goal.immigration": "Leben in Deutschland",
  "onboarding.goal.travel": "Reisen & Privat",
  "onboarding.board.telc": "telc",
  "onboarding.board.goethe": "Goethe",
  "onboarding.board.either": "Noch unsicher",
  "onboarding.level.none": "Kompletter Anfänger",
  "onboarding.level.A1": "A1 — einfache Sätze",
  "onboarding.level.A2": "A2 — Alltagsgrundlagen",
  "onboarding.level.B1": "B1 — selbstständig",
  "onboarding.level.B2": "B2 — sicher",
  "onboarding.level.C1": "C1 — fortgeschritten",
  "onboarding.quickCheck": "Unsicher? Hilfe bei der Wahl",
  "onboarding.quickCheck.q": "Was trifft am besten auf Sie zu?",
  "onboarding.quick.none": "Ich fange gerade erst an.",
  "onboarding.quick.A1": "Ich kann mich vorstellen und Essen bestellen.",
  "onboarding.quick.A2": "Ich kann über meinen Tag und Vergangenes sprechen.",
  "onboarding.quick.B1": "Ich komme auf Reisen zurecht und kann meine Meinung erklären.",
  "onboarding.quick.B2": "Ich kann mühelos über abstrakte Themen sprechen.",
  "onboarding.quick.C1": "Ich drücke mich fließend zu komplexen Themen aus.",
  "onboarding.timeline.relaxed": "Entspannt — etwas pro Woche",
  "onboarding.timeline.steady": "Regelmäßig — mehrmals pro Woche",
  "onboarding.timeline.intensive": "Intensiv — fast täglich",
  "dashboard.rec.eyebrow": "Ihre Empfehlung",
  "dashboard.rec.headline": "Wir empfehlen {level} — Komplett",
  "dashboard.rec.cta": "Ihren Plan ansehen",
  "dashboard.rec.bothBoards": "telc und Goethe",
  "dashboard.rec.credits": "Plus KI-Guthaben für Schreib- und Sprechfeedback.",
  "dashboard.rec.reason.exam": "Sie bereiten sich auf eine Prüfung vor — Komplett verbindet den {level}-Kurs mit vollständigen {board}-Prüfungsübungen und KI-Feedback, das Ihr Schreiben und Sprechen bewertet.",
  "dashboard.rec.reason.work": "Für den Beruf baut Komplett Ihr {level} von Grund auf auf — Kurs, prüfungsnahe Übungen und KI-Feedback.",
  "dashboard.rec.reason.study": "Fürs Studium führt Komplett Sie systematisch durch {level} — Kurs, Übungen im {board}-Format und KI-Feedback.",
  "dashboard.rec.reason.immigration": "Für das Leben in Deutschland deckt Komplett {level} ab — vom Alltagswortschatz bis zur {board}-Prüfung, mit KI-Feedback.",
  "dashboard.rec.reason.travel": "Komplett gibt Ihnen ein solides {level} — Kurs, Übungen und KI-Feedback, damit es sitzt.",

  "dashboard.greeting.morning": "Guten Morgen",
  "dashboard.greeting.day": "Guten Tag",
  "dashboard.greeting.evening": "Guten Abend",
  "dashboard.subtitle": "Das passiert gerade in Ihrem Arbeitsbereich.",
  "dashboard.admin.tenants": "Schulen, Plätze und Module verwalten.",
  "dashboard.admin.orders": "Überweisungsbestellungen, die auf Bestätigung warten.",
  "dashboard.admin.revenue": "Zahlungen und Umsatz über alle Mandanten.",
  "dashboard.admin.ai": "KI-Anbieter auswählen und Schlüssel verwalten.",

  "team.title": "Team",
  "team.invite": "Mitglied einladen",
  "team.invite.title": "Teammitglied einladen",
  "team.invite.name": "Vollständiger Name",
  "team.invite.role": "Rolle",
  "team.invite.submit": "Einladung senden",
  "team.resend": "Einladung erneut senden",
  "team.deactivate": "Deaktivieren",
  "team.activate": "Aktivieren",
  "team.status.active": "Aktiv",
  "team.status.inactive": "Inaktiv",
  "team.status.invited": "Eingeladen",

  "access.title": "Zugriff",
  "access.subtitle": "Berechtigungen über die Rolle hinaus erteilen oder entziehen.",
  "access.domain": "Bereich",
  "access.read": "Lesen",
  "access.write": "Schreiben",
  "access.granted": "erteilt",
  "access.revoked": "entzogen",
  "access.default": "Rollenstandard",

  "tenants.title": "Mandanten",
  "tenants.provision": "Neuer Mandant",
  "tenants.provision.title": "Mandant anlegen",
  "tenants.legalName": "Firmenname",
  "tenants.subdomain": "Subdomain",
  "tenants.tier": "Tarif",
  "tenants.adminEmail": "Admin-E-Mail",
  "tenants.adminName": "Admin-Name",
  "tenants.provision.submit": "Anlegen",
  "tenants.provisioned": "Mandant angelegt. Einladungslink (auch per E-Mail):",
  "tenants.levels": "Niveaus, die diese Schule gekauft hat",
  "tenants.levelsHint": "Jedes Niveau fügt seinen Kurs und seine Prüfungsübungen hinzu. Später auf der Schulseite änderbar.",
  "tenants.levelsAll": "Alle auswählen",
  "tenants.levelsNone": "Zurücksetzen",
  "tenants.provisionedNoEmail": "Schule angelegt. E-Mail ist auf diesem Server nicht konfiguriert — senden Sie diesen Link bitte selbst an die Administration:",
  "tenants.seats": "Plätze",
  "tenants.modules": "Module",
  "tenants.active": "Aktiv",
  "tenants.inactive": "Inaktiv",
  "tenants.seatPreview": "{n} Nutzer würden durch diese Änderung deaktiviert.",
  "tenants.save": "Änderungen speichern",

  "notifications.title": "Benachrichtigungen",
  "notifications.empty": "Alles erledigt.",
  "notifications.markAll": "Alle als gelesen markieren",

  "nav.learn": "Der Kurs",
  "learn.title": "Kurse",
  "learn.subtitle": "Ihr Deutschkurs, Stufe für Stufe.",
  "learn.enroll": "Einschreiben",
  "learn.enrolled": "Eingeschrieben",
  "learn.continue": "Weitermachen, wo Sie aufgehört haben",
  "learn.resume": "Fortsetzen",
  "learn.start": "Starten",
  "learn.review": "Wiederholen",
  "learn.completed": "Abgeschlossen",
  "learn.lessons": "Lektionen",
  "learn.mastery": "Beherrschung",
  "learn.xp": "XP",
  "learn.empty": "Noch keine Kurse veröffentlicht.",
  "nav.practice": "Pruefungsuebung",
  "nav.speak": "Sprechen",
  "bot.title": "Sprachpartner",
  "bot.subtitle": "Sprechen Sie frei mit Ihrem KI-Partner — er bleibt, bis Sie aufhören.",
  "bot.intro": "Einmal starten, dann einfach sprechen. Ihr Partner hört zu, antwortet laut, und das Mikrofon schaltet sich von selbst wieder ein — keine Tasten zwischendurch. Beenden Sie das Gespräch, wann Sie möchten, und Sie erhalten eine Rückmeldung.",
  "bot.language": "Sprache",
  "bot.level": "Niveau",
  "bot.levelAuto": "Automatisch (an mich anpassen)",
  "bot.levelAutoHint": "Wir wählen ein Niveau, sobald wir Ihr Sprechen kennen.",
  "bot.levelAutoAt": "Anhand Ihrer letzten Gespräche starten wir etwa bei {level}.",
  "bot.topic": "Thema",
  "bot.topicHint": "optional — leer lassen für ein freies Gespräch",
  "bot.howTitle": "So funktioniert es",
  "bot.howSpeak": "Sprechen Sie einfach - das Mikrofon ist schon an. Zwischen den Zuegen druecken Sie nichts.",
  "bot.howPause": "Lassen Sie sich Zeit. Nachdenken ist in Ordnung, es hoert weiter zu.",
  "bot.howStuck": "Fehlt Ihnen ein Wort? Sagen Sie es auf Englisch, oder tippen Sie unten.",
  "bot.howEnd": "Druecken Sie Beenden, wenn Sie genug haben - dann bekommen Sie Feedback.",
  "bot.partnerSpeaking": "Ihr Partner spricht...",
  "bot.voice": "Stimme",
  "bot.voiceHintServer": "maennlich oder weiblich - im Konto gespeichert, also auf jedem Geraet gleich",
  "bot.voiceMale": "Maennliche Stimme",
  "bot.voiceFemale": "Weibliche Stimme",
  "bot.voiceHint": "optional — manche Stimmen klingen deutlich natürlicher",
  "bot.voiceAuto": "Beste verfügbare",
  "bot.voiceTest": "Anhören",
  "bot.past": "Frühere Gespräche",
  "bot.backToStart": "Zurück",
  "bot.resumed": "Dort weiter, wo Sie aufgehört haben. Drücken Sie weiter, wenn Sie sprechen möchten.",
  "bot.continue": "Weitersprechen",
  "bot.topicPlaceholder": "z. B. Reisen, mein Beruf, Essen …",
  "bot.start": "Gespräch starten",
  "bot.end": "Beenden & Feedback erhalten",
  "practice.title": "Übungszentrum",
  "practice.status.preparingFor": "Sie bereiten sich vor auf",
  "practice.status.updateGoal": "Ziel ändern",
  "practice.status.nextUp": "Als Nächstes",
  "practice.status.noGoal": "Nennen Sie uns Ihr Ziel, um Ihr Üben zu personalisieren.",
  "practice.status.setGoal": "Ziel festlegen",
  "practice.status.goal.exam": "Wir machen Sie fit für die Prüfung.",
  "practice.status.goal.work": "Deutsch für Ihren Beruf.",
  "practice.status.goal.study": "Deutsch für Ihr Studium.",
  "practice.status.goal.immigration": "Deutsch für das Leben in Deutschland.",
  "practice.status.goal.travel": "Deutsch für Reisen.",
  "practice.subtitle": "Üben Sie jeden Prüfungsteil im echten Format.",
  "practice.practices": "Übungen",
  "practice.progress": "Fortschritt",
  "practice.start": "Übung starten",
  "practice.submit": "Abgeben",
  "practice.result": "Ergebnis",
  "practice.tryAgain": "Noch einmal",
  "practice.backToPart": "Zurück zu den Übungen",
  "practice.yourAnswer": "Ihre Antwort",
  "practice.correctAnswer": "Richtige Antwort",
  "practice.true": "Richtig",
  "practice.false": "Falsch",
  "practice.choose": "Auswählen…",
  "practice.best": "Beste",
  "practice.filter.all": "Alle",
  "practice.filter.notStarted": "Nicht begonnen",
  "practice.filter.keepPracticing": "Weiter üben",
  "practice.filter.mastered": "Gemeistert",
  "practice.readyToStart": "Bereit zum Start",
  "practice.practicedLabel": "Geübt",
  "practice.mastery": "Beherrschung",
  "practice.search": "Übungen suchen…",
  "practice.minutes": "Min.",
  "practice.howToApproach": "So gehen Sie vor",
  "practice.unanswered": "{n} noch offen",
  "practice.allAnswered": "Alle beantwortet",
  "practice.exam.cta": "Vollständige Prüfungssimulation",
  "practice.exam.ctaBody": "Absolvieren Sie die komplette Prüfung auf Zeit und erhalten Sie eine Auswertung pro Prüfungsteil.",
  "practice.exam.start": "Prüfung starten",
  "practice.exam.introBody": "{sections} Teile · ca. {minutes} Min. · {questions} Aufgaben. Lesen, Sprachbausteine und Hören werden sofort bewertet; Schreiben und Sprechen üben Sie separat.",
  "practice.exam.begin": "Prüfung beginnen",
  "practice.exam.allowed": "Erlaubt: {minutes} Min.",
  "practice.exam.finish": "Abgeben & bewerten",
  "practice.exam.passed": "Bestanden",
  "practice.exam.notPassed": "Weiter üben",
  "practice.exam.bySection": "Nach Prüfungsteil",
  "practice.exam.note": "Schreiben und Sprechen üben Sie separat mit den KI-Coaches.",
  "practice.exam.retake": "Neue Prüfung",
  "practice.exam.history": "Ihre letzten Versuche",
  "practice.readiness.label": "Prüfungsbereitschaft",
  "practice.readiness.detail": "{practiced} von {total} Aufgaben geübt",
  "practice.readiness.review": "Fehler wiederholen",
  "practice.readiness.avgLabel": "Bisheriger Durchschnitt",
  "practice.readiness.needMore": "Üben Sie {count} weitere Aufgaben für eine Einschätzung Ihrer Prüfungsbereitschaft.",
  "practice.readiness.needSections": "Noch nicht begonnen: {sections}",
  "practice.readiness.band.needsWork": "Noch üben",
  "practice.readiness.band.onTrack": "Auf Kurs",
  "practice.readiness.band.examReady": "Prüfungsbereit",
  "practice.review.subtitle": "Aufgaben, die Sie noch nicht gemeistert haben — die schwächsten zuerst. Üben Sie sie erneut, um Ihre Bereitschaft zu steigern.",
  "practice.review.empty": "Nichts zu wiederholen — alle versuchten Aufgaben sind gemeistert. Super!",
  "practice.explain.get": "KI-Erklärung erhalten",
  "practice.explain.notConfigured": "KI-Erklärungen sind auf diesem Server noch nicht aktiviert.",
  "practice.exam.band.sehrGut": "Sehr gut",
  "practice.exam.band.gut": "Gut",
  "practice.exam.band.bestanden": "Bestanden",
  "practice.exam.band.nichtBestanden": "Noch nicht",
  "practice.allThemes": "Alle Themen",
  "practice.previous": "Zurück",
  "practice.next": "Weiter",
  "practice.pageOf": "Seite {page} von {total}",

  "writing.aiCoach": "KI-Schreibcoach",
  "writing.getFeedback": "KI-Feedback erhalten",
  "writing.feedback": "KI-Feedback",
  "writing.levelEstimate": "Niveau-Einschätzung",
  "writing.content": "Inhalt",
  "writing.structure": "Aufbau & Ton",
  "writing.language": "Sprachliche Richtigkeit",
  "writing.taskPoints": "Leitpunkte",
  "writing.strengths": "Stärken",
  "writing.revise": "Überarbeiten & erneut senden",
  "writing.draftNote": "Notizen",
  "writing.draftNoteHint": "Ideen sammeln — wird nicht bewertet",
  "writing.previous": "Frühere Rückmeldungen",
  "writing.quotaUsed": "KI-Feedback diesen Monat: {used} / {limit}",

  "speaking.aiPartner": "KI-Sprechpartner",
  "speaking.notConfigured": "Der KI-Sprechpartner ist auf diesem Server noch nicht aktiviert — bitte wenden Sie sich an Ihre Administration.",
  "speaking.micUnavailable": "Spracheingabe ist in diesem Browser nicht verfügbar — Sie können Ihre Antworten stattdessen tippen.",
  "speaking.start": "Gespräch starten",
  "orb.speaking": "Ihr Partner spricht",
  "orb.listening": "Sie sind dran - sprechen Sie, wenn Sie bereit sind",
  "orb.thinking": "Denkt nach...",
  "orb.idle": "Bereit",
  "speaking.listening": "Ich höre zu…",
  "speaking.thinking": "Denke nach…",
  "speaking.typeFallback": "Antwort tippen",
  "speaking.send": "Senden",
  "speaking.end": "Beenden & Feedback erhalten",
  "speaking.turns": "Runde {turns} von {max}",
  "speaking.turnsWord": "Runden",
  "speaking.quotaUsed": "KI-Gespräche diesen Monat: {used} / {limit}",
  "speaking.feedback": "Gesprächs-Feedback",
  "speaking.interaction": "Interaktion & Aufgabe",
  "speaking.vocabulary": "Wortschatz",
  "speaking.grammar": "Grammatik",
  "speaking.transcript": "Protokoll",
  "speaking.tooShort": "Das Gespräch war zu kurz für eine Bewertung — versuchen Sie beim nächsten Mal ein längeres Gespräch.",
  "speaking.previous": "Frühere Gespräche",
  "speaking.you": "Sie",
  "speaking.partner": "Partner",

  "billing.title": "Abrechnung",
  "billing.subtitle": "Ihr Tarif, Ihre Plätze und Ihre Zahlungshistorie.",
  "billing.notConfigured": "Online-Zahlung ist auf diesem Server noch nicht aktiviert — bitte kontaktieren Sie uns für Ihren Tarif.",
  "billing.currentPlan": "Aktueller Tarif",
  "billing.trial": "Testphase",
  "billing.seats": "Plätze",
  "billing.renewsUntil": "Bezahlt bis",
  "billing.daysLeft": "Tage übrig",
  "billing.plans": "Tarife",
  "billing.monthly": "Monatlich",
  "billing.yearly": "Jährlich",
  "billing.month": "Monat",
  "billing.year": "Jahr",
  "billing.current": "Aktuell",
  "billing.choose": "Tarif wählen",
  "billing.renew": "Verlängern",
  "billing.contactUs": "Kontaktieren Sie uns",
  "billing.paid": "Zahlung erhalten — Ihr Tarif ist aktiv!",
  "billing.cancelled": "Zahlungsfenster geschlossen — es wurde nichts abgebucht.",
  "billing.orders": "Zahlungshistorie",
  "billing.date": "Datum",
  "billing.plan": "Tarif",
  "billing.amount": "Betrag",
  "billing.status": "Status",

  "revenue.title": "Umsatz",
  "revenue.subtitle": "Bezahlte Bestellungen über alle Mandanten.",
  "revenue.total": "Gesamteinnahmen",
  "revenue.paidOrders": "Bezahlte Bestellungen",
  "revenue.tenant": "Mandant",
  "revenue.empty": "Noch keine Zahlungen.",

  "dashboard.aiTitle": "Ihre KI-Coaches sind bereit",
  "dashboard.aiBody": "Erhalten Sie sofortiges, bewertetes Feedback zu Ihren Prüfungstexten und führen Sie fortlaufende Sprachgespräche mit dem KI-Sprechpartner — wie eine Expertin auf Abruf.",
  "dashboard.aiCta": "Zum Üben",
  "dashboard.examSkills": "Prüfungskompetenzen",
  "dashboard.examHint": "Die Beherrschung spiegelt Ihre besten Ergebnisse pro Prüfungsteil.",
  "dashboard.focusAreas": "Schwerpunkte",
  "dashboard.focusCommon": "Häufige B1-Schwerpunkte",
  "dashboard.focus.cases": "Die Kasuswahl wird in den Sprachbausteinen intensiv geprüft.",
  "dashboard.focus.clauses": "Wortstellungsregeln — das Verb steht am Ende.",
  "dashboard.focus.modals": "Sie kommen in fast jedem Teil-1-Text vor.",

  "monuments.title": "Wahrzeichen-Galerie",
  "monuments.subtitle": "Europäische Wahrzeichen — je in beiden Farbwelten.",

  "player.check": "Prüfen",
  "player.buildSentence": "Tippe die Wörter in der richtigen Reihenfolge an:",
  "player.continue": "Weiter",
  "player.mnemonic": "Merkhilfe",
  "player.tableMissing": "Diese Tabelle ist nicht verfügbar.",
  "player.yourText": "Ihr Text",
  "player.wordCount": "{count} Wörter",
  "player.compare": "Mit Musterlösung vergleichen",
  "player.modelAnswer": "Musterlösung",
  "player.saidIt": "Gesagt — Musterlösung zeigen",
  "player.correct": "Richtig!",
  "player.incorrect": "Nicht ganz.",
  "player.answerWas": "Antwort:",
  "player.loading": "Aufnahme wird geladen…",
  "player.listen": "Anhören",
  "player.pause": "Pause",
  "player.play": "Abspielen",
  "player.restart": "Neu starten",
  "player.speed": "Tempo",
  "player.transcript": "Transkript",
  "player.audioUnavailable": "Audio ist in diesem Browser nicht verfügbar — lesen Sie das Transkript unten.",
  "player.clear": "Löschen",
  "player.finish.title": "Lektion abgeschlossen!",
  "player.finish.score": "Ergebnis",
  "player.finish.backToCourse": "Zurück zum Kurs",
  "player.exit": "Lektion verlassen",

  "common.cancel": "Abbrechen",
  "common.showPassword": "Passwort anzeigen",
  "common.hidePassword": "Passwort verbergen",
  "common.close": "Schließen",
  "common.save": "Speichern",
  "common.saving": "Wird gespeichert…",

  "nav.ai": "KI-Einstellungen",
  "ai.title": "KI-Einstellungen",
  "ai.subtitle": "Legen Sie fest, welcher KI-Dienst Schreib-Feedback, Sprechübungen und Antwort-Erklärungen übernimmt. Die Änderung gilt sofort für alle Schulen.",
  "ai.provider": "KI-Anbieter",
  "ai.recommended": "empfohlen",
  "ai.noKey": "noch kein Schlüssel",
  "ai.keyPresent": "Schlüssel hinterlegt",
  "ai.keyMissing": "Kein Schlüssel hinterlegt",
  "ai.strictSchema": "Zuverlässiges Feedback-Format",
  "ai.looseSchema": "Feedback-Format nicht garantiert",
  "ai.noKeyHelp": "Für diesen Anbieter ist auf dem Server noch kein API-Schlüssel hinterlegt. Die KI-Funktionen bleiben ausgeschaltet, bis einer eingetragen wird.",
  "ai.looseSchemaHelp": "Dieser Anbieter kann das von uns geforderte Feedback-Format nicht garantieren. Wir prüfen jede Antwort und versuchen es einmal erneut, dennoch sind Ausfälle wahrscheinlicher als bei den anderen Anbietern.",
  "ai.saved": "KI-Anbieter aktualisiert.",
  "ai.saveFailed": "KI-Anbieter konnte nicht aktualisiert werden.",
  "common.loading": "Lädt…",
  "mock.noContent": "Fuer dieses Niveau gibt es noch keine Pruefungssimulation. Die Aufgaben werden noch ergaenzt.",
  "common.error.generic": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
  "doubt.title": "Frage stellen",
  "doubt.intro": "Kommen Sie nicht weiter? Fragen Sie in jeder Sprache — Hindi, Punjabi, Englisch — und wir antworten in dieser Sprache.",
  "doubt.placeholder": "z. B. Was ist der Unterschied zwischen 'der' und 'die'?",
  "doubt.ask": "Fragen",
  "doubt.off": "Der KI-Tutor ist derzeit nicht verfügbar.",
  "translate.tapHint": "Für die englische Übersetzung tippen",
  "translate.error": "Übersetzung fehlgeschlagen — zum Wiederholen tippen.",
  "common.required": "Pflichtfeld.",
};
